import React, { Component } from 'react';
import TrendReportTitleAndOptions from './TrendReportTitleAndOptions';
import TrendReportOEE from './oldComponents/TrendReportOEE';
import TrendReportLostTime from './oldComponents/TrendReportLostTime';
import TrendReportTrendingTopIssues from './oldComponents/TrendReportTrendingTopIssues';
import { CircularProgress } from '@material-ui/core';
import TrendReportIssueModal from './oldComponents/TrendReportIssueModal';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { getDate } from '../../DateTimeHelperUtils';
import HeaderTopNav from '../../HeaderTopNav';
import SideNav from '../../SideNav';
import Footer from '../../Footer';
import ReportsCard from '../../ReportsCard';

import EfficiencyChartIcon from '../../icons/EfficiencyChartIcon.svg';
import PlannedUnplannedChartIcon from '../../icons/PlannedUnplannedChartIcon.svg';
import UtilizationChartIcon from '../../icons/UtilizationChartIcon.svg';
import RunDetailsMetricsIcon from '../../icons/RunDetailsMetricsIcon.svg';

import TotalSensorCountIcon from '../../icons/TotalSensorCountIcon.svg';
import TotalReworkIcon from '../../icons/TotalReworkIcon.svg';
import TotalWasteIcon from '../../icons/TotalWasteIcon.svg';
import TotalDowntimeIcon from '../../icons/TotalDowntimeIcon.svg';
import LabourIcon from '../../icons/LabourIcon.svg';
import FinishedGoodsIcon from '../../icons/FinishedGoodsIcon.svg';

import RunTimelineDowntimeIcon from '../../icons/RunTimelineDowntimeIcon.svg';
import RunTimelineSpeedIcon from '../../icons/RunTimelineSpeedIcon.svg';
import TableEditIcon from '../../icons/TableEditIcon.svg';
import TableDeleteIcon from '../../icons/TableDeleteIcon.svg';

import ParetoChartIcon from '../../icons/ParetoChartIcon.svg';
import WasteChartIcon from '../../icons/WasteChartIcon.svg';
import ReworkChartIcon from '../../icons/ReworkChartIcon.svg';

import SkuBreakdownIcon from '../../icons/SkuBreakdownIcon.svg';
import ProductionHoursIcon from '../../icons/ProductionHoursIcon.svg';


import TrendReportChartOEE from './TrendReportChartOEE';
import TrendReportChartSKUBreakdown from './TrendReportChartSKUBreakdown';
import ReportEfficiencyChartNew from '../ReportEfficiencyChartNew';
import TrendReportDowntimePareto from './TrendReportDowntimePareto';
import TrendReportTopIssuesChart from './TrendReportTopIssuesChart';
import TrendReportUtilizationChart from './TrendReportUtilizationChart';
import TrendReportPlannedUnplannedChart from './TrendReportPlannedUnplannedChart';
import TrendReportProductionHours from './TrendReportProductionHours';
import TrendReportDrilldown from './TrendReportDrilldown';
import TrendReportChartSKUBarBreakdown from './TrendReportChartSKUBarBreakdown';
import moment from 'moment';

class TrendReportContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            lines: {},
            products: {},
            error: null,
            selected_lines: [],
            selected_products: [],
            date: getDate(),
            data: null,
            show_issue_modal: false,
            getting_report: false,
            modal_issue: '',
            number_of_weeks: 0,
            pareto_bars: 0,
            print_status: 'disabled',
            selected_lines_display: [],
            selected_products_display: [],
            selected_date_display: null,
            clicked_name: null,
            clicked_id: null,
            isCacheRebuilding: false,
            factory_name: '',
            collapse: true,

            applyDisabled: true,

            date_from: this.getTrailing7Days(),
            date_to: new Date(Date.now() - 24 * 60 * 60 * 1000),

            shifts: [],
            selected_shifts: [],

            selectedGranularity: [{ name: 'Day', id: 1 }],

            loading: false,
            reportData: {},

            show_drilldown: false,

            hoverIndex: null,

            skuType: "Duration",
            start_day_of_week: 0,
        };
    }

    /* -------- LIFECYCLE METHODS -------- */
    componentWillMount() {
        this.getFactorySettings();
        this.getShifts();
        this.getReport();
        LineStore.subscribeLines(this.handleLineChange);
        ProductStore.subscribeFull(this.handleProductStoreChange);
    }

    componentDidMount() {
        this.getFactorySettings();
    }

    componentWillUnmount() {
        LineStore.unsubscribe(this.handleLineChange);
        ProductStore.unsubscribe(this.handleProductStoreChange);
    }

    /* -------- FUNCTIONS -------- */

    getTrailing30Days = () => {
        let today = new Date(Date.now() - 24 * 60 * 60 * 1000);
        let last30 = new Date(today.setDate(today.getDate() - 30));
        return last30;
    };

    getTrailing7Days = () => {
        let today = new Date(Date.now() - 24 * 60 * 60 * 1000);
        let last7 = new Date(today.setDate(today.getDate() - 6));
        return last7;
    };

    getLastDayOccurence = (date, day) => {
        const d = new Date(date.getTime());
        const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        if (day) {
          const modifier = (d.getDay() + days.length - day) % 7 || 7;
          d.setDate(d.getDate() - modifier);
        }
        return d;
    }

    onFactoryChange = () => {
        this.setState({
            lines: {},
            products: {},
            error: null,
            selected_lines: [],
            selected_products: [],
            date: getDate(),
            data: null,
            show_issue_modal: false,
            getting_report: false,
            modal_issue: '',
            number_of_weeks: 0,
            pareto_bars: 0,
            print_status: 'disabled',
            selected_lines_display: [],
            selected_products_display: [],
            selected_date_display: null,
            clicked_name: null,
            clicked_id: null,
            isCacheRebuilding: false,
            factory_name: '',
            collapse: true,

            applyDisabled: true,

            date_from: this.getTrailing7Days(),
            date_to: new Date(Date.now() - 24 * 60 * 60 * 1000),

            shifts: [],
            selected_shifts: [],

            selectedGranularity: [{ name: 'Day', id: 1 }],

            loading: false,
            reportData: {},

            show_drilldown: false,

            hoverIndex: null,

            skuType: "Duration",
            start_day_of_week: 0,
        });
        LineStore.clear();
        ProductStore.clearFull();
        // this.getFactorySettings();
        LineStore.fetchLines();
        ProductStore.fetch();
        this.getFactorySettings();
        this.getShifts();
        this.getReport(true);
    };

    onCollapseClickChange = collapse => {
        this.setState({ collapse });
    };

    print = () => {
        this.setState({
            print_status: 'printing'
        });

        let line_name = this.state.selected_lines_display[0]
            ? this.state.lines.find(line => line.line_id === this.state.selected_lines_display[0]).line_name
            : 'All Lines';

        if (this.state.selected_lines_display.length > 1) {
            line_name = 'Multi-line';
        }

        if (this.state.selected_lines_display.length === this.state.lines.length) {
            line_name = 'All Lines';
        }

        let product_description = this.state.selected_products_display[0]
            ? this.state.products.find(product => product.product_id === this.state.selected_products_display[0])
                  .display_name
            : 'All Products';

        if (this.state.selected_products_display.length > 1) {
            product_description = 'Multi-product';
        }

        if (this.state.selected_products_display.length === this.state.products.length) {
            product_description = 'All Products';
        }

        let title = `${line_name} - ${product_description} - ${Util.formatDateMMMDDYYYY(
            this.state.selected_date_display
        )}`;

        let doc = new jsPDF({ format: 'letter' }); // 8.5" x 11" paper size
        let count = 3;

        html2canvas(document.getElementById('oee-chart'), { logging: false }).then(canvas => {
            doc.addImage(document.getElementById('logo'), 'JPEG', 8, 4, 40, 8);
            doc.setDrawColor(41, 103, 193);
            doc.setLineWidth(0.5);
            doc.line(0, 16, 215.9, 16);

            doc.setFontSize(16);
            doc.text(`${this.state.factory_name} - Weekly Trend Report`, 8, 24);
            doc.text(title, 8, 30);

            let img = canvas.toDataURL('image/png');
            doc.addImage(img, 'JPEG', 0, 34, 121, 78);
            count--;
            this.checkHtml2CanvasCount(count, doc, title);
        });

        html2canvas(document.getElementById('lost-time-pareto'), { logging: false }).then(paretoCanvas => {
            let paretoImg = paretoCanvas.toDataURL('image/png');
            doc.addImage(paretoImg, 'JPEG', 125, 34, 80, 80);
            count--;
            this.checkHtml2CanvasCount(count, doc, title);
        });

        html2canvas(document.getElementById('top-four-charts'), { logging: false }).then(topFourCanvas => {
            let topFourImg = topFourCanvas.toDataURL('image/png');
            doc.addImage(topFourImg, 'JPEG', 0, 120, 210, 125);
            count--;
            this.checkHtml2CanvasCount(count, doc, title);
        });
    };

    checkHtml2CanvasCount = (count, doc, title) => {
        if (count === 0) {
            doc.setDrawColor(41, 103, 193);
            doc.setLineWidth(0.5);
            doc.line(0, 268, 215.9, 268);

            doc.setFontSize(6);
            doc.text(`${this.state.factory_name} - Weekly Trend Report - ${title}`, 207.9, 272, null, null, 'right');
            doc.save(`Weekly Trend Report - ${title}.pdf`);
            this.setState({
                print_status: 'enabled'
            });
        }
    };

    handleLineChange = () => {
        this.setState({
            lines: LineStore.getLines(),
            selected_lines: this.getSelectedLines()
        });
    };

    // handleLineChangeOnFactoryChange = () => {
    //     this.setState({
    //         lines: LineStore.getLines(),
    //     });
    // };

    getSelectedLines() {
        let selectedLines = [];
        let allLines = LineStore.getLines();

        if (allLines[0]) {
            allLines.forEach(line => {
                selectedLines.push(line.id);
            });
        }

        return selectedLines;
    }

    handleProductStoreChange = () => {
        this.setState({
            products: ProductStore.get(),
            selected_products: this.getSelectedProducts()
        });
    };

    getSelectedProducts() {
        let selectedProducts = [];

        if (this.state.selected_products[0]) {
            selectedProducts = this.state.selected_products;
        } else {
            let allProducts = ProductStore.get();

            if (allProducts.length > 0) {
                allProducts.forEach(product => {
                    selectedProducts.push(product.product_id);
                });
            }
        }

        return selectedProducts;
    }

    handleDateChange = date => {
        this.setState({
            date
        });
    };

    handleSelectLines = selected_lines => {
        let updatedSelection = Array.from(selected_lines);
        let newArray = [];
        updatedSelection.forEach(line => {
            if (line.id) {
                newArray.push(line.id);
            }
            else {
                newArray.push(line);
            }
        })
        this.setState({
            selected_lines: newArray,
            applyDisabled: false,
        });
    };

    handleSelectProducts = selected_products => {
        let updatedSelection = Array.from(selected_products);
        this.setState({
            selected_products: updatedSelection
        });
    };

    hideModal = () => {
        this.setState({
            show_issue_modal: false,
            clicked_name: null,
            clicked_id: null
        });
    };

    showModal = props => {
        this.setState({
            show_issue_modal: true,
            clicked_name: props.activeLabel,
            clicked_id: props.activePayload[0].payload.id
        });
    };

    onLostTimeBarHover = props => {
        if (props.activeTooltipIndex !== undefined) {
            this.setState({
                hoverIndex: props.activeTooltipIndex
            });
        } else {
            this.setState({
                hoverIndex: -1
            });
        }
    };

    /* -------- API CALLS -------- */

    getReport = (fresh) => {
        this.setState({ show_drilldown: false, clickedReason: null })

        const payload = {
            start_range_date: this.state.date_from,
            end_range_date: this.state.date_to,
            granularity: this.state.selectedGranularity[0].name.toLowerCase(),
            number_of_trends: this.state.selectedGranularity[0].name === 'Day' ? 7 : this.state.selectedGranularity[0].name === 'Week' ? 4 : 3,
            line_id: this.state.selected_lines,
            // line_id: [],
            // product_id: this.state.selected_products,
            shift_id: this.state.selected_shifts.map((i) => i.id)
        }

        if (fresh === true) {
            payload.line_id = []
        }

        this.setState({ loading: true })

        let params = {
            path: 'get_trend_report',
            data: payload,
            success: (data) => this.setState({ reportData: data, loading: false }),
            error: () => { this.setState({ loading: false }) }
        };

        API.c(params, 2);
    }

    getShifts = () => {
        const currentDate = moment.utc().format('YYYY-MM-DD');
        let params = {
            path: 'get_shift',
            success: (data) => {
                const newArr = data.sort(function compare(a, b) {
                    const datea = moment(`${currentDate} ${a.start_time}`).format('HH:mm:ss');
                    const dateb = moment(`${currentDate} ${b.start_time}`).format('HH:mm:ss');
                    return datea.localeCompare(dateb);
                });
                // setShifts(newArr);
                this.setState({ shifts: newArr })
            },
            error: () => {}
        };

        API.c(params);
    };

    getFactorySettings = () => {
        this.setState({
            getting_report: true
        });

        let params = {
            path: 'get_factory_settings',
            success: this.onGetFactorySettingsSuccess,
            error: this.onGetFactorySettingsError
        };

        API.c(params, 2);
    };

    onGetFactorySettingsSuccess = data => {
        localStorage.setItem("efficiency_string_long", data.efficiency_string_long)
        localStorage.setItem("efficiency_string_short", data.efficiency_string_short)
        const date = this.getLastDayOccurence(new Date(), data.start_day_of_week);
        // const date_to = this.getLastDayOccurence(new Date(), data.start_day_of_week);
        // date_to.setDate(date_to.getDate() - 1);
        let today = new Date();
        const date_from = this.getTrailing7Days();
        const date_to = new Date(Date.now() - 24 * 60 * 60 * 1000)
        this.setState(
            {
                number_of_weeks: data.default_weeks_weekly_trend ? data.default_weeks_weekly_trend : 52,
                pareto_bars: data.default_weekly_pareto_bars ? data.default_weekly_pareto_bars : 10,
                factory_name: data.name,
                usesShifts: data.uses_shifts,
                start_day_of_week: data.start_day_of_week ? data.start_day_of_week : 0,
                // date_from: new Date(date.getTime() - 7 * 24 * 60 * 60 * 1000),
                date_from: date_from,
                date_to: date_to
            },
            this.getWeeklyTrend
        );
    };

    onGetFactorySettingsError = error => {
        this.setState({
            error
        });
    };

    getShortReason = reason => {
        let r = reason;

        if (reason.length > 25) {
            r = reason.substr(0, 22);
            r += '...';
        }

        return r;
    };

    onGetWeeklyTrendSuccess = data => {
        this.setState({
            getting_report: false,
            print_status: 'enabled',
            selected_lines_display: this.state.selected_lines,
            selected_products_display: this.state.selected_products,
            selected_date_display: this.state.date,
            isCacheRebuilding: data.is_cache_rebuilding,
            data
        });

        if (data.is_cache_rebuilding) {
            setTimeout(this.getWeeklyTrend, 30000);
        }
    };

    onGetWeeklyTrendError = error => {
        this.setState({
            getting_report: false,
            error: error ? error : 'Error Getting The Trend Report'
        });
    };

    /* -------- RENDERS -------- */

    renderOptionsSelectors = () => {
        return (
            <TrendReportTitleAndOptions

                applyDisabled={this.state.applyDisabled}
                loading={this.state.loading}

                date={this.state.date}

                date_from={this.state.date_from}
                date_to={this.state.date_to}
                setReportRangeDates={(date_from, date_to) => this.setState({ applyDisabled: false, date_from, date_to })}

                lines={this.state.lines}
                selected_lines={this.state.selected_lines}
                handleSelectLines={this.handleSelectLines}

                usesShifts={this.state.usesShifts}
                shifts={this.state.shifts}
                selectedShifts={this.state.selected_shifts}
                handleSelectShifts={selected_shifts => this.setState({ applyDisabled: false, selected_shifts })}

                selectedGranularity={this.state.selectedGranularity}
                handleSelectGranularity={selectedGranularity => this.setState({ applyDisabled: false, selectedGranularity })}

                getReport={this.getReport}

                start_day_of_week={this.state.start_day_of_week}
            />
        );
    };

    renderReport = () => {
        if (this.state.getting_report) {
            return (
                <div className="reports__container">
                    <div className="card__flex-box">
                        <CircularProgress />
                    </div>
                </div>
            );
        }

        if (this.state.error) {
            return (
                <div className="reports__container">
                    <div className="card__flex-box">{this.state.error}</div>
                </div>
            );
        }

        return (
            <div className="reports__container">
                <div className="flex-box__col" style={{ flex: 1 }}>
                    <div className="flex-box__row justify-space-around align-start">
                        <div style={{ width: '60%' }}>
                            <TrendReportOEE oee={this.state.data.weekly_efficiency_range_list} />
                        </div>
                        <div style={{ width: '40%' }}>
                            <TrendReportLostTime
                                four_week_lost_time={this.state.data.four_week_lost_time_list}
                                onMouseMove={this.onLostTimeBarHover}
                                pareto_bars={this.state.pareto_bars}
                                onBarClick={this.showModal}
                            />
                        </div>
                    </div>
                    <div style={{ width: '100%' }}>
                        <TrendReportTrendingTopIssues
                            topIssue={this.state.data.top_lost_time_seconds_range_list}
                            hoverIndex={this.state.hoverIndex}
                        />
                    </div>
                </div>
            </div>
        );
    };

    renderPrintArea = () => {
        if (this.state.data) {
            let printStyle = {
                maxWidth: '1345px',
                minWidth: '1345px',
                marginLeft: 'auto',
                marginRight: 'auto'
            };

            return (
                <div style={{ left: 10000, position: 'fixed', background: '#fff' }}>
                    <div className="flex-box__col" style={printStyle}>
                        <div className="flex-box__row justify-space-around align-start">
                            <div id="oee-chart" style={{ width: '60%' }}>
                                <TrendReportOEE oee={this.state.data.weekly_efficiency_range_list} />
                            </div>
                            <div id="lost-time-pareto" style={{ width: '40%' }}>
                                <TrendReportLostTime
                                    four_week_lost_time={this.state.data.four_week_lost_time_list}
                                    onMouseMove={this.onLostTimeBarHover}
                                    pareto_bars={this.state.pareto_bars}
                                    onBarClick={this.showModal}
                                />{' '}
                                :<div>&nbsp;</div>
                            </div>
                        </div>
                        <div id="top-four-charts" style={{ width: '100%' }}>
                            <TrendReportTrendingTopIssues
                                topIssue={this.state.data.top_lost_time_seconds_range_list}
                                hoverIndex={this.state.hoverIndex}
                            />{' '}
                            :<div>&nbsp;</div>
                        </div>
                    </div>
                </div>
            );
        }
    };

    renderIssueModal = () => {
        if (this.state.show_issue_modal) {
            return (
                <TrendReportIssueModal
                    hideModal={this.hideModal}
                    selected_lines={this.state.selected_lines}
                    selected_products={this.state.selected_products}
                    date={this.state.date}
                    id={this.state.clicked_id}
                    name={this.state.clicked_name}
                    issue={this.state.modal_issue}
                />
            );
        } else {
            return <div />;
        }
    };

    onBarClick = (e) => {
        if (e.reason === this.state.clickedReason) {
            this.setState({ 
                clickedReason: null, 
                show_drilldown: false 
            })
        } 
        else { 
            this.setState({ 
                clickedReason: e.reason, 
                clickedReasonId: e.reason_id,
                show_drilldown: true 
            })
        } 
    }

    onHover = (id) => {
        this.setState({ hoverIndex: id });
    }

    changeSKUType = (e) => {
        this.setState({ skuType: e.target.value });
    }

    render() {
        let class_name = this.state.collapse ? 'reports--collapse' : 'reports';
        let header_class_name = this.state.collapse ? "header header--collapse" : "header"

        return (
            <div className="container">
                <HeaderTopNav className={header_class_name} onFactoryChange={this.onFactoryChange} />
                <SideNav
                    onShowScoreboardClicked={() => {}}
                    onCollapseClick={this.onCollapseClickChange}
                    title="Reports"
                />
                <div className="main_content_wrapper" style={{ marginTop: "57px", background: "white", marginLeft: "97px" }}>
                    <div style={{ display: 'flex', width: "1280px", margin: "auto", flexDirection: 'column', justifyContent: 'space-between' }}>
                        <div style={{ marginTop: "6px" }}>
                            {this.renderOptionsSelectors()}
                            { this.state.reportData && this.state.reportData.sku_aggregate_dict && this.state.reportData.sku_aggregate_dict.length > 0 ? (
                                <>
                                    <div style={{ background: "white", padding: "10px 30px 30px 30px" }}>
                                    <div style={{ marginBottom: "24px" }}>
                                        <ReportsCard tooltip={`This graph displays historical OEE (Overall Equipment Effectiveness) over time. The trendline provides a smoothed view, calculated as: \n • 7-day rolling average for daily data \n • 4-week rolling average for weekly data \n • 3-month rolling average for monthly data`} size="large" icon={EfficiencyChartIcon} title="OEE Trend" height="400px">
                                            <TrendReportChartOEE granularity={this.state.selectedGranularity[0].name} granular_efficiency_range_list={this.state.reportData && this.state.reportData.granular_efficiency_range_list ? this.state.reportData.granular_efficiency_range_list : []} />
                                        </ReportsCard>
                                    </div>

                                    <div style={{ display: "flex", justifyContent: "center", gap: "24px", alignItems: "center", marginBottom: "24px" }}>
                                        <ReportsCard tooltip="This section highlights your top 10 SKUs based on Overall Equipment Effectiveness (OEE) and the total runtime on the line. Use this data to identify high-performing products and assess their operational impact." size="large" icon={SkuBreakdownIcon} title="SKU Breakdown" height="400px">
                                            <TrendReportChartSKUBreakdown type={this.state.skuType} onHover={this.onHover} duration={true} sku_aggregate_dict={this.state.reportData && this.state.reportData.sku_aggregate_dict ? this.state.reportData.sku_aggregate_dict : []} />
                                        </ReportsCard>
                                    </div>

                                    <div style={{ marginBottom: "24px" }}>
                                        <ReportsCard tooltip="This chart reveals your leading causes of downtime, helping to pinpoint key areas for improvement. Click on a bar to expand and view detailed historical data for that specific downtime reason." size="large" mainBoxStyles={{ alignItems: "baseline", height: "85%", flexDirection: "column" }} icon={ParetoChartIcon} title="Trending Downtimes" height={this.state.show_drilldown ? "730px" : "400px"}>
                                            <TrendReportDowntimePareto
                                                onClick={(e) => this.onBarClick(e)}
                                                active_lost_time_reason={this.state.clickedReason}
                                                report={this.state.reportData} 
                                                perPage={10}
                                                lostTimeOpen={this.state.show_drilldown}
                                                reset_active_lost_time_reason={() => this.setState({ show_drilldown: false, clickedReason: null, clickedReasonId: null })}
                                                />
                                            <TrendReportDrilldown
                                                reportData={this.state.reportData}
                                                date_from={this.state.date_from}
                                                date_to={this.state.date_to}
                                                granularity={this.state.selectedGranularity[0].name.toLowerCase()}
                                                line_id={this.state.selected_lines}
                                                shift_id={this.state.selected_shifts.map((i) => i.id)}
                                                number_of_trends={this.state.selectedGranularity[0].name === 'Day' ? 7 : this.state.selectedGranularity[0].name === 'Week' ? 4 : 3}
                                                reason={this.state.clickedReason}
                                                reason_id={this.state.clickedReasonId}
                                                hideModal={() => this.setState({ show_drilldown: false, clickedReason: null, clickedReasonId: null })}
                                                open={ this.state.show_drilldown }
                                            />
                                        </ReportsCard>
                                    </div>

                                    <div style={{ marginBottom: "24px" }}>
                                        <ReportsCard tooltip="This chart illustrates how much of the available time was utilized for production runs. Analyze this metric to assess operational efficiency and identify opportunities to optimize line usage." size="large" icon={UtilizationChartIcon} title="Utilization" height="400px">
                                            <TrendReportUtilizationChart granularity={this.state.selectedGranularity[0].name} granular_efficiency_range_list={this.state.reportData && this.state.reportData.granular_efficiency_range_list ? this.state.reportData.granular_efficiency_range_list : []} />
                                        </ReportsCard>
                                    </div>
                                    <div style={{ marginBottom: "24px" }}>
                                        <ReportsCard tooltip="This chart compares planned downtime (expected reasons, such as scheduled maintenance) with unplanned downtime (unexpected disruptions). Use this insight to evaluate the predictability of your operations and improve planning strategies." size="large" icon={PlannedUnplannedChartIcon} title="Planned vs Unplanned" height="400px">
                                            <TrendReportPlannedUnplannedChart granular_efficiency_range_list={this.state.reportData && this.state.reportData.granular_efficiency_range_list ? this.state.reportData.granular_efficiency_range_list : []} />
                                        </ReportsCard>
                                    </div>
                                    <div style={{ marginBottom: "24px" }}>
                                        <ReportsCard tooltip="This section displays the total hours your production lines were actively running. Use this data to monitor overall production activity and identify trends in operational output over time." size="large" icon={ProductionHoursIcon} title="Total Production Hours" height="400px">
                                            <TrendReportProductionHours granularity={this.state.selectedGranularity[0].name} granular_efficiency_range_list={this.state.reportData && this.state.reportData.granular_efficiency_range_list ? this.state.reportData.granular_efficiency_range_list : []} />
                                        </ReportsCard>
                                    </div>
                                </div>
                                </>

                            ) : this.state.loading ? (
                                <div style={{ height: "67vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <CircularProgress />
                                </div>
                            ) : (
                                <div style={{ height: "67vh" }}>
                                    <p style={{ fontSize: "24px" }}>No runs in range selected</p>
                                </div>
                            )}  

                            <Footer />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default TrendReportContainer;
